module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dashboard-widget', {
    attrs: {
      "is-loading": _vm.isLoading
    }
  }, [
    [_c('div', {
      staticClass: "active-leads-wrapper"
    }, [_c('div', {
      staticClass: "widget-header"
    }, [_c('h4', {
      staticClass: "inline-block"
    }, [_vm._v(_vm._s(_vm.$t('ui.dashboard.active_leads.label')))])]), _vm._v(" "), _c('div', {
      staticClass: "card-wrapper row"
    }, _vm._l((_vm.mostActiveLeads), function(mostActiveLead) {
      return _c('div', {
        key: mostActiveLead.index,
        staticClass: "lead-card col-xs-4 col-md-2"
      }, [_c('div', {
        staticClass: "icon-classification"
      }, [(mostActiveLead.classification === 'warm') ? _c('img', {
        staticClass: "align-center",
        attrs: {
          "src": require("../../../../../assets/leads-count-yellow.svg")
        }
      }) : (mostActiveLead.classification === 'hot') ? _c('img', {
        staticClass: "align-center",
        attrs: {
          "src": require("../../../../../assets/leads-count-red.svg")
        }
      }) : (mostActiveLead.classification === 'cold') ? _c('img', {
        staticClass: "align-center",
        attrs: {
          "src": require("../../../../../assets/lead-count-cold-green.svg")
        }
      }) : _c('img', {
        staticClass: "align-center",
        attrs: {
          "src": require("../../../../../assets/leads-count-gray.svg")
        }
      })]), _vm._v(" "), _c('div', [_c('p', {
        staticClass: "truncate-text"
      }, [_vm._v("\n                    " + _vm._s(mostActiveLead.name))]), _vm._v(" "), _c('p', {
        staticClass: "caption truncate-text"
      }, [_vm._v(_vm._s(mostActiveLead.company))])])])
    }), 0)])]
  ], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0528c590","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/dashboard/widgets/widgets/MostActiveLeadsWidget.vue
// module id = 1798
// module chunks = 0